import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";

const usersUrlApi = environment.usersUrlApi;
const userUrlApi = environment.userUrlApi;
const blockUnblockUrlApi = environment.blockUnblockUserById;
const userAssignGroupsUrlApi = environment.userAssignGroupsUrlApi;
const userAssignRolesUrlApi = environment.userAssignRolesUrlApi;
const userAssignDevicesToMeUrlApi = environment.userAssignDevicesToMeUrlApi;
const userAssignDevicesToUserUrlApi = environment.userAssignDevicesToUserUrlApi;

const userAssignPoliceStationToUserUrlApi =
  environment.userAssignPoliceStationToUserUrlApi;

const devicesUserUrlApi = environment.devicesUserUrlApi;
const usersForShareVideoUrlApi = environment.getUsersListVideoSharedExcluded;
const usersForShareIncidentUrlApi =
  environment.getUsersListIncidentSharedExcluded;

@Injectable()
export class UserService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getUsers() {
    return this.http
      .request("GET", `${usersUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getUsersForShareVideoByIdUser(id: number) {
    return this.http
      .request("GET", `${usersForShareVideoUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getUsersForShareIncidentByIdUser(id: number) {
    return this.http
      .request("GET", `${usersForShareIncidentUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getUserById(id: number) {
    return this.http
      .request("GET", `${userUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateUserById(id: number, userModel: UserForm) {
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("PUT", `${userUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createUser(userModel: UserForm) {
    delete userModel.password2;
    userModel.active = 1;
    const body = userModel;
    return this.http
      .request("POST", `${userUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteUserById(id: number) {
    return this.http
      .request("DELETE", `${userUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  changeStatusUserById(id: number, status: boolean) {
    const body = { active: !status };
    return this.http
      .request("PUT", `${blockUnblockUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  assignGroups(idUser: number, arrayGroupsSelected) {
    const body = { id_groups: arrayGroupsSelected };
    return this.http
      .request("PUT", `${userAssignGroupsUrlApi}/` + idUser, { body })
      .pipe(map((resp: any) => resp));
  }

  assignRoles(idUser: number, arrayGroupsSelected) {
    const body = { id_roles: arrayGroupsSelected };
    return this.http
      .request("PUT", `${userAssignRolesUrlApi}/` + idUser, { body })
      .pipe(map((resp: any) => resp));
  }

  assignDevicesToMe(idDevice: number) {
    return this.http
      .request("POST", `${userAssignDevicesToMeUrlApi}/` + idDevice)
      .pipe(map((resp: any) => resp));
  }

  assignDevicesToUser(idDevice: number, idUser: number) {
    const body = { id_user: idUser, id_device: idDevice };
    return this.http
      .request("POST", `${userAssignDevicesToUserUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  removeDeviceToUser(id: number) {
    return this.http
      .request("DELETE", `${devicesUserUrlApi}/` + id)
      .pipe(map((resp: any) => resp));
  }

  assignPoliceStationsToUser(idRole: number, arrayRolesSelected) {
    const body = { id_permissions: arrayRolesSelected };
    return this.http
      .request("PUT", `${userAssignPoliceStationToUserUrlApi}/` + idRole, {
        body,
      })
      .pipe(map((resp: any) => resp));
  }
}
